export default {
  availableDates: [{ CurrentState: "Undefined" }],
  availableHours: [{ CurrentState: "Undefined" }],
  enrollee: {},
  locations: [{ CurrentState: "Undefined" }],
  vehicle: [{ CurrentState: "Undefined" }],
  referringSite: "lifesafer",
  statesList: [{ CurrentState: "Undefined" }],
};
